import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HotelTourCalendarDatesService {
  constructor() {
  }

  getDatesDiapason(dateFrom: string, dateTo: string) {
    const startDate = new Date(dateFrom);
    const endDate = new Date(dateTo);

    const dateFormatter = new Intl.DateTimeFormat('ru-RU', {
      day: 'numeric',
      month: 'long',
    });

    return {dateFrom: dateFormatter.format(startDate), dateTo: dateFormatter.format(endDate)};
  }

  getDatesGrid(dateFrom:string, dateTo:string) {
    const startDate = new Date(dateFrom);
    const endDate = new Date(dateTo);

    const dates: { day: string; weekday: string; month: string; date: string }[] = [];
    const currentDate = new Date(startDate);

    const weekdayFormatter = new Intl.DateTimeFormat('ru-RU', {
      weekday: 'short',
    });

    const monthFormatter = new Intl.DateTimeFormat('ru-RU', {
      month: 'long',
    });

    while (currentDate <= endDate) {
      const formattedDate = currentDate.getDate().toString().padStart(2, '0');
      const formattedWeekday = weekdayFormatter.format(currentDate);
      const formattedMonth = monthFormatter.format(currentDate);
      dates.push({
        day: formattedDate,
        weekday: formattedWeekday,
        month: formattedMonth,
        date: currentDate.toISOString().split('T')[0], // ISO формат только с датой
      });
      currentDate.setDate(currentDate.getDate() + 1); // Увеличиваем на 1 день
    }

    return dates;
  }

  getFormattedDateString(date: Date) {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
  }
}
